import { useState } from 'react';
import { SftpConnectionsApi } from '@/api/clients/sftp-connections/sftp-connections.api';

export const useTestSftpConnection = (organizationId, connectionId) => {
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const testConnection = async (overrides = {}) => {
    setTesting(true);
    setTestResult(null);

    try {
      const response = await SftpConnectionsApi.testSftpConnection(
        organizationId,
        connectionId,
        overrides,
      );
      setTestResult(response.data.data);
    } finally {
      setTesting(false);
    }
  };

  const clearTestResult = () => setTestResult(null);

  return { testing, testResult, testConnection, clearTestResult };
};
